import React, { Suspense, useState } from "react";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { IObservationEvent } from "../../interfaces/IObservationEvent";
import { Button, Modal, ModalProps, Segment } from "semantic-ui-react";
import ObservationPackageDetails from "./ObservationPackageModal";

const getTextProps = (t: TFunction) => ({
    originalObservation: t("Alkuperäinen havainto"),
    close: t("Sulje"),

})


const OriginalModal: React.FC<ModalProps & { event: IObservationEvent }> = ({ event, ...props }) => {
    const texts = getTextProps(useTranslation().t);
    const [open, setOpen] = useState(false);

    if (!event.historyPackageId) {
        return null;
    };

    return (
        <Modal
            {...props}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            closeIcon
        >
            <Modal.Header content={texts.originalObservation} />
            <Modal.Content>
                <Suspense fallback={<Segment basic placeholder loading />}>
                    <ObservationPackageDetails packageId={event.historyPackageId} />
                </Suspense>
            </Modal.Content>
            <Modal.Actions>
                <Button content={texts.close} onClick={() => setOpen(false)} />
            </Modal.Actions>
        </Modal>
    )
}



export default OriginalModal;
